/* ============================================================
   Custom Announcement Bar — Content-width slider
   ============================================================
   Measures the widest announcement text and constrains the
   slider container to that width. Dawn's slideshow-component
   JS continues to work normally since slides remain equal-width.
   ============================================================ */

(function() {
  function initAnnouncementBarWidth() {
    const section = document.querySelector('.announcement-bar-section');
    if (!section) return;

    const slides = section.querySelectorAll('.announcement-bar__message');
    if (slides.length === 0) return;

    const slider = section.querySelector('.announcement-bar-slider');
    const singleBar = section.querySelector('.announcement-bar--one-announcement');
    const target = slider || singleBar;
    if (!target) return;

    /* Measure the widest slide text */
    let maxWidth = 0;

    slides.forEach(function(slide) {
      /* Temporarily make visible and measurable */
      const clone = slide.cloneNode(true);
      clone.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;width:auto;display:inline-flex;';
      document.body.appendChild(clone);
      const width = clone.offsetWidth;
      document.body.removeChild(clone);

      if (width > maxWidth) {
        maxWidth = width;
      }
    });

    if (maxWidth > 0) {
      /* Add padding for arrows + breathing room */
      const arrows = target.querySelectorAll('.slider-button');
      let arrowsWidth = 0;
      arrows.forEach(function(arrow) {
        arrowsWidth += arrow.offsetWidth;
      });

      const totalWidth = maxWidth + arrowsWidth + 48; /* 48px for gaps */

      target.style.maxWidth = totalWidth + 'px';
      target.style.margin = '0 auto';
    }
  }

  /* Run on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBarWidth);
  } else {
    initAnnouncementBarWidth();
  }

  /* Re-run on window resize (debounced) */
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAnnouncementBarWidth, 200);
  });

  /* Handle theme editor reloads */
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAnnouncementBarWidth);
  }
})();